import {
  LifeCycleActions,
  LifeCycleActionTypes
} from './life-cycle.actions';

export interface LifeCycleState {
  init: boolean;
  config: boolean;
  documentService: boolean;
  /**
   * true - user is authenticated
   * false - user is not authenticated
   * null - authenticated is unknown
   */
  auth: boolean | null;
  stable: boolean;
  navigated: boolean;
}

export const LIFE_CYCLE_INIT: LifeCycleState = {
  init:            false,
  config:          false,
  documentService: false,
  auth:            null,
  stable:          false,
  navigated:       false
};

export function lifeCycleReducer(state: LifeCycleState = LIFE_CYCLE_INIT, action: LifeCycleActions): LifeCycleState {

  switch (action.type) {

    case LifeCycleActionTypes.AppAuthenticated:
      return { ...state, auth: true };

    case LifeCycleActionTypes.AppConfigLoaded:
      return { ...state, config: true };

    case LifeCycleActionTypes.AppDocumentServiceLoaded:
      return { ...state, documentService: true };

    case LifeCycleActionTypes.AppInit:
      return { ...state, init: true };

    case LifeCycleActionTypes.AppIsStable:
      return { ...state, stable: true };

    case LifeCycleActionTypes.AppIsUnstable:
      return { ...state, stable: false };

    case LifeCycleActionTypes.AppUnauthenticated:
      return { ...state, auth: false };

    case LifeCycleActionTypes.AppStartNavigate:
      return { ...state, navigated: false };

    case LifeCycleActionTypes.AppStopNavigate:
      return { ...state, navigated: true };


    default:
      return state;

  }

}
